var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slideInMenu", class: { "is-open": _vm.isOpen } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isOpen
          ? _c("div", {
              staticClass: "slideInMenu__background",
              on: { click: _vm.close }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slideInMenu__inner" }, [
        _vm.isOpen
          ? _c("div", { staticClass: "slideInMenu__nav" }, [
              _c(
                "div",
                {
                  staticClass: "slideInMenu__nav__close",
                  on: { click: _vm.close }
                },
                [_c("close-icon")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "slideInMenu__nav__basket" },
                [_vm._t("tools")],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "slideInMenu__body customscroll" },
          [_vm._t("body")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }